import React from "react"
import kebabCase from "lodash/kebabCase"

const Tag = class extends React.Component {

  onTagClick = () => {
    const { slug, onTagClick, selected} = this.props
    if (onTagClick !== undefined && slug !== undefined) {
      onTagClick(slug, selected)
    }
  }

  render() {
    const { title, selected, category } = this.props
    const categoryClass = category === undefined ? "" : `is-${kebabCase(category)}`
    return (
      <button 
        className={`tag ${categoryClass} ${selected ? "is-active" : ""}`}
        onClick={this.onTagClick} 
        dangerouslySetInnerHTML={{__html: title}} 
        type="button"
        aria-label={title}
      />
    )
  }
}

export default Tag